var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-vue-btn"},[_c('a',{staticClass:"btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('showWeddingItineraryModal',true)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file'],"full-width":""}}),_vm._v("\n        See Sample Itenerary\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }